/**
 * Masks an IMEI string for display, keeping only the last `visibleSuffix`
 * characters readable. Returns the raw value when it's too short to mask
 * meaningfully (≤ visibleSuffix characters).
 *
 * Example: `maskImei("354023050000001", 4)` → `"•••••••••••0001"`.
 *
 * Different surfaces use different masking lengths — the picker shows more
 * characters (matches the original IMEI length so it stays visually anchored),
 * while the cart line keeps it compact (always four bullets).
 */
export function maskImei(imei: string, visibleSuffix = 4): string {
  if (imei.length <= visibleSuffix) return imei;
  const bullets = "•".repeat(Math.max(4, imei.length - visibleSuffix));
  return `${bullets}${imei.slice(-visibleSuffix)}`;
}

/**
 * Compact mask for cart-line / drawer use: always four bullets + last four
 * digits, regardless of input length.
 */
export function maskImeiCompact(imei: string): string {
  if (imei.length <= 4) return imei;
  return `••••${imei.slice(-4)}`;
}
